export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 KB';
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}

/** "in 23 hours" style copy for the retention countdown. */
export function formatRemaining(expiresAt: number, now = Date.now()): string {
  const ms = expiresAt - now;
  if (ms <= 0) return 'expired';

  const minutes = Math.floor(ms / 60_000);
  if (minutes < 1) return 'under a minute';
  if (minutes < 60) return minutes + (minutes === 1 ? ' minute' : ' minutes');

  const hours = Math.floor(minutes / 60);
  const spare = minutes % 60;
  if (hours < 24) {
    return spare > 0 ? hours + 'h ' + spare + 'm' : hours + (hours === 1 ? ' hour' : ' hours');
  }
  return Math.floor(hours / 24) + ' days';
}

const SOURCE_LABELS: Record<string, string> = {
  device: 'Device',
  dropbox: 'Dropbox',
  'google-drive': 'Google Drive',
  onedrive: 'OneDrive',
};

export function sourceLabel(source: string): string {
  return SOURCE_LABELS[source] ?? source;
}

/** Percentage saved against the original, or null when the file grew. */
export function savings(originalBytes: number, outputBytes: number): number | null {
  if (originalBytes <= 0 || outputBytes <= 0 || outputBytes >= originalBytes) return null;
  return Math.round((1 - outputBytes / originalBytes) * 100);
}
